import Alpine from 'alpinejs'

const data = (params = {}) => ({
  /**
   *  Data
   */
  mapping: [
    '@gmail.com',
    '@hotmail.com',
    '@yahoo.com.tw',
    '@outlook.com'
  ],

  /**
   *  Targets
   */

  targets: {
    input: {
      ['@keydown.enter.prevent']: '',
      ['@keyup']: 'autoFill'
    }
  },

  /**
   *  Main & Event Callback
   */

  init() {
  },

  autoFill() {
    if ( this.$event.code === 'Backspace' || this.$event.code === 'ArrowLeft' || this.$event.code === 'ArrowRight' ) { return }

    const suffix = this.$el.value.replace(/^.*?@/i, '@')
    if ( suffix === '@' ) { return }

    const suffixEmail = this.mapping.find( word => word.match(new RegExp(`^${suffix}`)) )
    if ( !suffixEmail ) { return }

    const originalValue = this.$el.value
    this.$el.value = this.$el.value.replace(/@.*?$/, suffixEmail)
    // NOTICE: 把輸入後面補上的部分選起來, 而且input[type=email]沒有支援selection
    this.$el.focus()
    this.$el.setSelectionRange(originalValue.length, this.$el.value.length)
  },

  /**
   *  Public Function
   */

  /**
   *  Value Changed
   */

  /**
   *  Private Function
   */

  ...params
})

Alpine.data('AutoFillEmail', data)
export default data
